import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { computed as r } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function e(o, t) {
  return r(() => {
    for (const n of t)
      if (o[n] !== void 0)
        return o[n];
    return o[t[t.length - 1]];
  });
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/use-compitable.js
// module id = 324
// module chunks = 41